import ArchiveLayout from '@/layouts/ArchiveLayout';
import { FAQS_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Frequently Asked Questions',
  el: 'Συχνές Ερωτήσεις',
};

const description: Record<Locale, string> = {
  en: 'Find answers to the most common questions.',
  el: 'Βρείτε απαντήσεις στις πιο συχνές ερωτήσεις.',
};

const eyebrow: Record<Locale, string> = {
  en: 'FAQ',
  el: 'FAQ',
};

const emptyState: Record<Locale, string> = {
  en: 'No FAQs available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμες συχνές ερωτήσεις αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function FaqsArchive() {
  return (
    <ArchiveLayout
      pageKey="faqs"
      postType="faqs"
      query={FAQS_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
